import Paths from '@lib/paths';

export interface BottomLinkItem {
  cta: string;
  iconAlt?: string;
  iconUrl: string;
  segmentEventPrefix: string;
  title: string;
  href?: string;
  target?: string;
}

export const bottomLinks: BottomLinkItem[] = [
  {
    cta: 'Try the credit simulator',
    iconAlt: 'Chart trending upwards',
    iconUrl:
      'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/images/chart_upwards_blue.png',
    segmentEventPrefix: 'Credit Simulator',
    title: 'See what could build your credit',
    href: `${process.env.NEXT_PUBLIC_EXTERNAL_BASE_URL}${Paths.DASHBOARD_CREDIT_SCORE_GOAL_AND_TIPS}`,
  },
  /* {
    cta: 'See my full credit report',
    iconAlt: 'Folded paper',
    iconUrl:
      'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/images/folded_paper_blue.png',
    segmentEventPrefix: 'Credit Report',
    title: 'Want to see more details?',
    href: `${process.env.NEXT_PUBLIC_EXTERNAL_BASE_URL}${Paths.DASHBOARD_CREDIT_SCORE_FULL_REPORT}`
  },*/
  {
    cta: 'Join the community',
    href: 'https://support.nerdwallet.com/hc/en-us/community/topics/360001364712-Tracking-My-Credit-Score',
    iconAlt: 'Blue lightbulb',
    iconUrl:
      'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/images/lightbulb_blue.png',
    segmentEventPrefix: 'Credit Community',
    target: '_blank',
    title: 'Ask questions, get answers. This credit-building forum is for you.',
  },
  {
    cta: 'Dispute an error with TransUnion',
    href: 'https://www.transunion.com/credit-disputes/dispute-your-credit',
    iconAlt: 'Blue Warning',
    iconUrl:
      'https://www.nerdwallet.com/cdn/nodeapp/my-nerdwallet/images/warning_blue.png',
    segmentEventPrefix: 'TU Dispute',
    target: '_blank',
    title: "See something that doesn't look right?",
  },
];
